import styled from 'styled-components';

export const LoginPage = styled.div`
  display: flex;
  height: 100vh;
`;

export const LoginSection = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackgroundSection = styled.div`
  width: 50%;
  background-image: url('/sandback.jpg');
  background-size: cover;
  background-position: center;
`;

export const LoginTitle = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #111827;
`;

export const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 400px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #D1D5DB;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  
  &:focus {
    outline: none;
    border-color: #133b5c;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 0.5rem 1rem;
  background-color: #133b5c;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    background-color: #133b5c;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
  }
`;